import { AtsApplicationSource } from "./ats-application-source";
import { AtsOrganization } from "./ats-organization";
import { AtsImportTaskExtended } from "./monitor-application-imports";
import { SearchResult } from "./search-result";

export class ApplicationSourceTracking {
    Id: string;
    HistoryId: string;
    Success: boolean;
    HasValidationError: boolean;
    DateUpdatedUtc: Date;
    Origin: string;
    OriginEnvironment: string;
    OriginTags: string[];
    Attempts: number;
    Extended: AtsImportTaskExtended;
}

export class ApplicationImportTrackingMetaData {
    OrganizationId: string;
    SeasonId: string;
    DateCreatedUtc: Date;
    DateUpdatedUtc: Date;
}

export class ApplicationImportTracking {
    Id: string;
    ApplicationId: string | null;
    CasApplicationId: number | null;
    OrganizationName: string;
    ApplicationSources: ApplicationSourceTracking[] | null;
    ApplicationSourcesSuccess: boolean;
    AppSyncSuccess: boolean;
    Success: boolean;
    AppSync: AppSyncTracking | null;
    MetaData: ApplicationImportTrackingMetaData;
}

export type ApplicationImportTrackingFilter = {
    organization?: AtsOrganization;
    source?: AtsApplicationSource;
    status?: boolean;
    subStatus?: string;
    appImportSource?: string;
    range?: Range;
    origin?: string;
    originEnvironment?: string;
    originTag?: string;
};

export class ApplicationImportTrackingSearchResult extends SearchResult<ApplicationImportTracking> {}

export interface AppSyncError {
    AppSyncResultId: string;
    DateUtc: string;
    Message: string;
    StatusCode: number | null;
}

export class AppSyncTracking {
    AppSyncResultId: string;
    CasOrganizationId: number;
    LastSuccessUtc: string | null;
    FirstAttemptUtc: string | null;
    LastAttemptUtc: string | null;
    NextAttemptUtc: string | null;
    Attempts: number;
    Disabled: boolean;
    Errors: AppSyncError[];
}
